import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-coupon-search',
  templateUrl: './coupon-search.component.html',
  styleUrls: ['./coupon-search.component.css']
})
export class CouponSearchComponent implements OnInit {
  form: FormGroup;
  constructor(private fb: FormBuilder, private dialog: MatDialogRef<CouponSearchComponent>) { }

  ngOnInit() {
    this.createForm();
  }
  createForm() {

    this.form = this.fb.group({
      FullName: [null],
      NationalCode: [null],
      StudentNationalCode: [null]
    });

  }
  submit(data: any) {
    this.dialog.close(data);
  }

  onNoClick() {
    this.dialog.close();
  }

}
